<template>
  <div id="m-redactor" style="height: 100%">
    <v-overlay v-if="loading">
      <v-progress-circular indeterminate color="primary"/>
    </v-overlay>
    <v-alert type="error" width="20%" v-else-if="message" style="margin-top: 50px;margin-left: 50%;left: -10%;">
      {{ message }}
    </v-alert>
    <div v-else class="d-flex">
      <v-layout style="width: 256px">
        <vue-perfect-scrollbar class="scrollbar">
          <menu-view :name-game="nameGame" :name-config="nameConfig" :readonly="readonly"/>
        </vue-perfect-scrollbar>
      </v-layout>
      <v-layout style="width: 100%;">
        <vue-perfect-scrollbar class="scrollbar">
          <router-view :key="routeViewKey"/>
        </vue-perfect-scrollbar>
      </v-layout>
    </div>
  </div>
</template>

<script>

import MenuView from "@/modules/redactor/menu/MenuView";
import RedactorStore from "@/modules/redactor/core/RedactorStore";

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export default {
  components: {MenuView, VuePerfectScrollbar},
  data: () => ({
    nameGame: "",
    nameConfig: "",
    loading: true,
    readonly: false,
    message: ""
  }),
  computed: {
    routeViewKey() {
      if (!this.$store.hasModule(RedactorStore.name)) {
        return this.$route.fullPath;
      }

      const getter = this.$store.getters[RedactorStore.name + "/getLoadRevision"];
      const revision = typeof getter === "function" ? getter() : 0;

      return `${this.$route.fullPath}:${revision}`;
    }
  },
  beforeMount() {
    this.nameGame = "undefined";
    this.nameConfig = this.$route.params.name;

    this.readonly = this.$route.params.readonly;

    if (!this.$store.hasModule(RedactorStore.name)) {
      this.$store.registerModule(RedactorStore.name, RedactorStore);
    }

    this.$store.dispatch(RedactorStore.name + "/init", {
      uid: this.$route.params.uid,
      path: this.$route.params.path,
      readonly: this.$route.params.readonly,
      sharedMode: Boolean(this.$route.query.shared)
    }).then(() => {
      this.$notify({text: 'Valid Config.', type: "success"});
    }).catch((error) => {
      let reason = "";

      if (error instanceof Error) {
        reason = error.message;
      } else if (Array.isArray(error)) {
        reason = error.map(v => JSON.stringify(v)).join('<br>');
      } else {
        reason = JSON.stringify(error);
      }

      this.$notify({text: 'Invalid Config:' + reason, type: "error", duration: -1});
    }).finally(() => {
      const map = RedactorUtils.getCurrentMapKind();

      this.nameGame = this.$route.query.shared ? "SHARED" : (map ? map.key : "undefined");
      this.loading = false;
    });
  },
  destroyed() {
    console.log("destroy root view redactor");
    this.$store.dispatch(RedactorStore.name + "/clear");
  }
}

</script>

<style lang="scss" scoped>
.scrollbar {
  width: 100%;
  height: calc(100vh - 68px);
  overflow: auto;
}
</style>
